"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _once = _interopRequireDefault(require("transmute/once"));

var _configureFileManager = _interopRequireDefault(require("FileManagerLib/components/configureFileManager"));

function configureFileManagerWithTracking(uploadedFileAccess, tracker) {
  return (0, _configureFileManager.default)({
    uploadedFileAccess: uploadedFileAccess,
    usageTracker: tracker
  });
}

var _default = (0, _once.default)(configureFileManagerWithTracking);

exports.default = _default;
module.exports = exports.default;